const data = [
  ['规则', '词', '值'],
  ['规则一', '搞笑幽默', 3535333],
  ['规则一', '新闻趣事', 786129],
  ['规则一', '视频音乐', 745129],
  ['规则一', '八卦杂谈', 692445],
  ['规则一', '旅游', 609399],
  ['规则一', '名人明星', 595030],
  ['规则一', '美食', 547503],
  ['规则一', '美女', 426973],
  ['规则一', '校园生活', 410200],
  ['规则一', 'IT数码', 285640],
  ['规则一', '情感生活', 242144],
  ['规则一', '星座运势', 236689],
  ['规则一', '体育资讯', 212234],
  ['规则一', '美图摄影', 212139],
  ['规则一', '动漫', 206044],
  ['规则一', '美容服饰', 195679],
  ['规则一', '读书分享', 128521],
  ['规则一', '宠物图集', 128508],
  ['规则一', '视频电影', 96778],
  ['规则二', '科学探索', 95826],
  ['规则二', '车世界', 86178],
  ['规则二', '微博奇葩', 81244],
  ['规则二', '职场招聘', 80363],
  ['规则二', '娱乐', 76280],
  ['规则二', '游戏', 75128],
  ['规则二', '星座命理', 72777],
  ['规则二', '北京生活', 63456],
  ['规则二', '财经资讯', 55711],
  ['规则二', '其他生活', 55204],
  ['规则二', '时尚', 53971],
  ['规则二', '音乐', 50297],
  ['规则二', '育儿百科', 49836],
  ['规则二', '军事天地', 49286],
  ['规则二', '健康', 49098],
  ['规则二', '穿衣美容', 47014],
  ['规则二', '新闻热点', 41924],
  ['规则二', '文艺', 41620],
  ['规则二', '教育', 40089],
  ['规则二', '重口味', 37254],
  ['规则二', '健康养生', 36692],
  ['规则二', '萌宠', 33947],
  ['规则二', '上海生活', 31537],
  ['规则二', '自媒体', 31396],
  ['规则二', '房产', 29908],
  ['规则二', '深圳生活', 29184],
  ['规则二', '体育', 27797],
  ['规则二', '电影', 26218],
  ['规则二', '90后', 26106],
  ['规则二', '投资理财', 25983],
  ['规则二', '新闻资讯', 25934],
];

export default data;



// WEBPACK FOOTER //
// ./src/containers/EChartsEditor/wordCloudData.js